import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectEmailTemplateDictionary } from '../../../../redux/modules/app';
import { renderHtml } from '../../../../utils/htmlUtil';

function PreviewRow({ html, title }) {
  const dictionary = useSelector(selectEmailTemplateDictionary);

  return (
    <Flex mb={2}>
      <Box className="text-left pl-4 pt-2 pr-title" flexBasis="10%" xs="2">
        <strong>{title}</strong>
      </Box>
      <Box className="text-left pl-4 pt-2 pr-html" flexBasis="90%" xs="10">
        {html && renderHtml(html, {})}
      </Box>
    </Flex>
  );
}

PreviewRow.propTypes = { html: PropTypes.string.isRequired, title: PropTypes.string.isRequired };

export default PreviewRow;
